module.exports = __webpack_public_path__ + "static/media/graph1.b718363f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/DashboardMulti/graph1.jpg
// module id = 551
// module chunks = 0